import Cookies from "js-cookie"
import { atom } from "recoil"
import { Session, STORAGE } from "./types"

export const forgotPasswordEmailState = atom<string | undefined>({
  key: "forgotPasswordEmailState",
  default: undefined,
})

export const sessionState = atom<Session | undefined>({
  key: "Session",
  default: {
    jwt: Cookies.get(STORAGE.JWT) ?? "",
    userId: Cookies.get(STORAGE.USER_ID) ?? "",
    role: Cookies.get(STORAGE.ROLE) ?? "",
  },
})

export const loggingOutState = atom<boolean>({
  key: "loggingOutState",
  default: false,
})

/** In-memory client filter preference, reset when the user logs out. */
export const hideDisconnectedClientsState = atom<boolean>({
  key: "hideDisconnectedClientsState",
  default: false,
})

export const transcriptRecordingState = atom<boolean>({
  key: "transcriptRecordingState",
  default: false,
})

export const enableScheduledItemTabState = atom<boolean>({
  key: "enableScheduledItemTabState",
  default: true,
})

export const currentRiskAlertPathState = atom<string | undefined>({
  key: "currentRiskAlertPathState",
  default: undefined,
})
